/**
 * Module Dependencies
 */
import state from './state.js'
import getters from './getters.js'
import actions from './actions.js'
import mutations from './mutations.js'

/**
 * User Subscription Module Declaration
 *
 * @type {Object}
 */
const module = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}

export default module



// WEBPACK FOOTER //
// ./src/state/modules/user/subscription/index.js